import { useCartCount } from '../../hooks';

import { Svg } from '../Svg';

export function CartHeader({ closeCart, announcement, isCartPage }) {
  const cartCount = useCartCount();

  return (
    <>
      <div className="relative flex items-center justify-between px-[18px] pb-3 pt-[18px]">
        <h3 className="cart-header-heading text-base text-primary font-normal">
          Your Cart{' '}
          <span className={`${isCartPage ? '' : 'lg:hidden'}`}>
            ({cartCount || 0})
          </span>
        </h3>

        <button
          aria-label="Close cart"
          className={`w-6 h-6 p-[6px] ${isCartPage ? 'hidden' : ''}`}
          onClick={closeCart}
          type="button"
        >
          <Svg
            className="text-text"
            src="/svgs/close.svg#close"
            title="Close Cart"
            viewBox="0 0 24 24"
          />
        </button>
      </div>
      {announcement?.enabled && (
        <div>
          <p className="bg-[#CCE0F1] px-3 py-[.6rem] text-center text-xs font-light text-black">
            {announcement?.text}
          </p>
        </div>
      )}
    </>
  );
}

CartHeader.displayName = 'CartHeader';
